import api from '.'
import { CustomersReq } from './customers.types'

export const CustomersKey = {
	search: (query: CustomersReq) => ['customers', query],
}

const CustomersApi = {
	search: (query: CustomersReq) =>
		api
			.get<PaginatedAPIRes<CategorySearchResult[]>>(`/customers`, { params: query })
			.then((res) => res.data),
}

export default CustomersApi
